import {useEffect, useState} from "react";
import {getUTCNow} from "./Helper";

export const TIMER_INTERVAL_KEY = "TIMER_INTERVAL_ID";

function millisToMinutesAndSeconds(millis: number) {
    const minutes = Math.floor(millis / 60000);
    const seconds = ((millis % 60000) / 1000).toFixed(0);
    return minutes + ":" + (+seconds < 10 ? '0' : '') + seconds;
}

export default function useElapsedTime(dateTimeStarted: Date) {
    const [timeCharged, setTimeCharged] = useState({diff: 0, timeElapsed: ""});

    function setTime() {
        const diff = Math.abs(getUTCNow() - new Date(dateTimeStarted).getTime());
        setTimeCharged({diff: diff, timeElapsed: millisToMinutesAndSeconds(diff)})
    }

    useEffect(() => {
        const timerIntervalId = localStorage.getItem(TIMER_INTERVAL_KEY);
        if (timerIntervalId) {
            clearInterval(+timerIntervalId)
        }
        setTime();
        const intervalId = window.setInterval(() => {
            setTime();
        }, 1000)
        localStorage.setItem(TIMER_INTERVAL_KEY, intervalId.toString());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dateTimeStarted])

    return timeCharged;
}
